import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Progress(theme: Theme): Components<Theme> {
  const isLight = theme.palette.mode === "light";

  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          overflow: "hidden",
          variants: [
            {
              props: { color: "primary" },
              style: {
                backgroundColor:
                  theme.palette.primary[isLight ? "lighter" : "darker"],
              },
            },
          ],
        },
        bar: {
          borderRadius: 4,
        },
      },
    },
  };
}
